import { getApiBase } from './apiBase'

export type OkMainHero = { id: number; name: string; imageUrl?: string; isBonus?: boolean }
export type OkMainZoneHero = { id: number; heroId: number }
export type OkMainZone = { id: number; faction: number; point1?: number; point2?: number; point3?: number; heros: OkMainZoneHero[]; eventHeroId?: number | null; controlStartDate?: number | null }

const base = getApiBase()

const TTL = 5 * 60 * 1000

function getCache<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return null
    const obj = JSON.parse(raw)
    if (!obj || typeof obj !== 'object') return null
    if (Date.now() - obj.t > TTL) return null
    return obj.v as T
  } catch {
    return null
  }
}

function setCache<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify({ t: Date.now(), v: value }))
  } catch { }
}

async function getJson<T>(path: string): Promise<T> {
  const normalizedPath = path.startsWith('/api/')
    ? path
    : `/api${path.startsWith('/') ? path : `/${path}`}`
  const url = `${base}${normalizedPath}`
  const res = await fetch(url)
  if (!res.ok) {
    if (res.status === 403) {
      try {
        const err = await res.clone().json()
        if (err.error === 'ACCOUNT_BANNED') {
          console.error('[API] Account banned. Forcing logout.')
          localStorage.clear()
          window.location.href = '/'
          return Promise.reject('ACCOUNT_BANNED')
        }
      } catch { }
    }
    throw new Error(`Request failed: ${res.status}`)
  }
  return res.json() as Promise<T>
}

export async function fetchZones(): Promise<OkMainZone[]> {
  // Disable cache for zones as they are now mutable on server
  // const cached = getCache<OkMainZone[]>('okmain_zones')
  // if (cached) return cached
  const data: any = await getJson<any>('/zones')
  const list: OkMainZone[] = Array.isArray(data) ? data : (data?.list || [])
  // setCache('okmain_zones', list)
  return list
}

export async function fetchHeros(): Promise<OkMainHero[]> {
  const cached = getCache<OkMainHero[]>('okmain_heros')
  if (cached) return cached
  const data: any = await getJson<any>('/heros')
  let list: OkMainHero[] = Array.isArray(data) ? data : (data?.list || [])
  // Map Erok-Buru to Verg for player display (AI keeps Erok-Buru internally)
  list = list.map(h => h.name === 'Erok-Buru' ? { ...h, name: 'Verg' } : h)
  setCache('okmain_heros', list)
  return list
}
